import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.showBackLink}}\n  <BackLink />\n{{/if}}\n<SingleEvent @event={{this.model}} />\n", {
  moduleName: "ilios-common/templates/events.hbs"
});